export const getTicketTopics = (user: {}, isPlayer: Boolean = false) => {
  const ticketList = [
    {
      label: 'ขอเปลี่ยนแปลงตำแหน่งงานยูเซอร์แอดมิน',
      value: 'updateChangeRoleAdmin',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'ตรวจสอบรายการวางเดิมพัน หรือ ตรวจสอบผลจบเดิมพัน',
      value: 'checkBetSettled',
      permissions: [],
      isPlayer: true,
    },
    {
      label: 'ขอแก้ไขชื่อบัญชีลูกค้า',
      value: 'changeBankAccountName',
      permissions: [],
      isPlayer: true,
    },
    {
      label: 'ขอเปลี่ยนเบอร์มือถือลูกค้า',
      value: 'changeUsername',
      permissions: [],
      isPlayer: true,
    },
    {
      label: 'ขอระงับการใช้งานยูเซอร์แอดมิน',
      value: 'inactiveUserAdmin',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'ขอสร้างยูเซอร์แอดมินคนใหม่',
      value: 'createNewUserAdmin',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'ขอเปลี่ยนเลขที่บัญชี',
      value: 'changeBankAccountNo',
      permissions: [],
      isPlayer: true,
    },
    {
      label: 'ตรวจสอบรายการที่ไม่จบเดิมพัน',
      value: 'betNotSettled',
      permissions: [],
      isPlayer: true,
    },
    {
      label: 'ขอเพิ่มหรือลบเวป ออกจากสิทธิ์ยูเซอร์แอดมิน',
      value: 'addRemoveOperationList',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'ขอเปลี่ยน LINE@',
      value: 'updateLineOa',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'แจ้งเล่นเกมไม่ได้',
      value: 'cantPlaygame',
      permissions: [],
      isPlayer: true,
    },
    {
      label: 'เช็คยอดคอมมิชชั่นหรือค่าพันธมิตร',
      value: 'checkCommissionAffiliate',
      permissions: [],
      isPlayer: true,
    },
    {
      label: 'ขอเคลียร์ยอดติด Hold Balance',
      value: 'clearHoldBalance',
      permissions: [],
      isPlayer: true,
    },
    {
      label: 'แอดมินขอเปลี่ยนพาสเวิร์ด',
      value: 'requestChangeUsernamePasswordAdmin',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'แอดมินขอรีเซทกูเกิ้ล ออเทน',
      value: 'adminRequestResetgoogleAuth',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'แอดมินขอรีเซทเบอร์มือถือ',
      value: 'adminRequestResetMobileNo',
      permissions: [],
      isPlayer: false,
    },
    //new
    {
      label: 'ขอแจ้งปัญหาการใช้งาน CMS',
      value: 'cantUseCms',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'แจ้งไม่พบรายการฝากหรือถอนที่ CMS',
      value: 'depositAndWithdrawnCms',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'ปรับจำนวนครั้งการถอนต่อวัน',
      value: 'updateWithdrawLimit',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'ขอปรับเพิ่มหรือลด Valid Balance',
      value: 'updateValidBalance',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'แจ้งปัญหา Loyalty Point',
      value: 'loyaltyPoint',
      permissions: [],
      isPlayer: false,
    },
    {
      label: 'คำขออื่นๆ',
      value: 'other',
      permissions: [],
      isPlayer: false,
    },
  ]
  if (isPlayer) {
    return ticketList.filter((topic) => topic && topic.isPlayer == true)
  }
  return ticketList.filter((topic) => topic)
}

export const getTicketStatuses = (state: any) =>
  [
    //   'ส่งคำขอ':'#97979C',
    // 'กำลังดำเนินการ':'#F98233',
    // 'โปรแกรมเมอร์กำลังแก้':'#F17EAD',
    // 'ข้อมูลไม่ถูกต้อง':'#DC646A',
    // 'ตรวจสอบ provider':'#F5d907',
    // 'เสร็จแล้ว':'#33A069',
    // 'ปิดตั๋ว':'#33A069',
    {
      label: 'ส่งคำขอ',
      value: 'ส่งคำขอ',
      permissions: [],
    },
    {
      label: 'กำลังดำเนินการ',
      value: 'กำลังดำเนินการ',
      permissions: [],
    },
    {
      label: 'โปรแกรมเมอร์กำลังแก้',
      value: 'โปรแกรมเมอร์กำลังแก้',
      permissions: [],
    },
    {
      label: 'ข้อมูลไม่ถูกต้อง',
      value: 'ข้อมูลไม่ถูกต้อง',
      permissions: [],
    },
    {
      label: 'ตรวจสอบ provider',
      value: 'ตรวจสอบ provider',
      permissions: [],
    },
    {
      label: 'เสร็จแล้ว',
      value: 'เสร็จแล้ว',
      permissions: [],
    },
    {
      label: 'ปิดตั๋ว',
      value: 'ปิดตั๋ว',
      permissions: [],
    },
    {
      label: 'ขอข้อมูลเพิ่มเติม',
      value: 'ขอข้อมูลเพิ่มเติม',
      permissions: [],
    },
    {
      label: 'ยกเลิกคำขอ',
      value: 'ยกเลิกคำขอ',
      permissions: [],
    },
  ]
    // .map((topic) => ({
    //   ...topic,
    //   label: state.language === 'th'  ? topic.labelTh : topic.label,
    // }));
    .filter((topic) => topic /** TODO: handler user permission */)

export const ticketStatusColors: any = {
  // backlog: '#87909e',
  // 'to do': '#6985ff',
  // 'in progress': '#40a6e6',
  // bug: '#dc646a',
  // blocked: '#dc646a',
  // 'dev done': '#33a069',
  // qa: '#f17ead',
  // cancel: '#d86369',
  // 'qa passed & wait deploy': '#d86369',
  // deployed: '#33A069',
  ส่งคำขอ: '#97979C',
  กำลังดำเนินการ: '#F98233',
  โปรแกรมเมอร์กำลังแก้: '#F17EAD',
  ข้อมูลไม่ถูกต้อง: '#DC646A',
  'ตรวจสอบ provider': '#F5d907',
  เสร็จแล้ว: '#33A069',
  ปิดตั๋ว: '#33A069',
  ยกเลิกคำขอ: '#FF6666',
  ขอข้อมูลเพิ่มเติม: '#CC99FF',
  'รอ payment gateway แก้ไข': '#466BF6',
}

export const getAmountType = () => [
  {
    label: 'ปรับเพิ่ม',
    value: 'ปรับเพิ่ม',
  },
  {
    label: 'ปรับลด',
    value: 'ปรับลด',
  },
]

export const getLoyaltyIssue = () => [
  {
    label: 'กดรับได้หลายรอบ',
    value: 'กดรับได้หลายรอบ',
  },
  {
    label: 'Point หมดอายุ',
    value: 'Point หมดอายุ',
  },
  {
    label: 'Point ติดลบ',
    value: 'Point ติดลบ',
  },
]

export const getCommissionIssue = () => [
  {
    label: 'ค่าคอมมิชชั่น',
    value: 'ค่าคอมมิชชั่น',
  },
  {
    label: 'ค่าพันธมิตร',
    value: 'ค่าพันธมิตร',
  },
]

export const getOperatorIssue = () => [
  {
    label: 'เพิ่ม',
    value: 'เพิ่ม',
  },
  {
    label: 'ลบ',
    value: 'ลบ',
  },
]

export const getPaymentType = () => [
  {
    label: 'รายการฝาก',
    value: 'รายการฝาก',
  },
  {
    label: 'รายการถอน',
    value: 'รายการถอน',
  },
]
